<template>
  <component
    v-if="currentPage !== undefined"
    :is="calledComponent"
    :currentPage="currentPage"
    @open-categories="$_discoverAssortment" />
</template>

<script>

import { mapGetters, mapActions } from 'vuex'
import Common from './Common/Common.vue'

// 
import Academy from '../Academy/Academy.vue'
import Company from '../Company/Company.vue'
import Contacts from '../Contacts/Contacts.vue'
import Quality from '../Quality/Quality.vue'
import Services from '../Services/Services.vue'
import CookiePolicy from '../CookiePolicy/CookiePolicy.vue'
// import CookiePolicy from '../CookiePolicy/CookiePolicy.vue'

export default {
  data: () => ({
    loading: true,
    componentsMap: {
      'Academy': Academy,
      'Company': Company,
      'Contacts': Contacts,
      'Quality': Quality,
      'Services': Services,
      'CookiePolicy': CookiePolicy
    }
  }),
  props: {
    slug: {
      type: String,
      required: true
    }
  },
  computed: {
    ...mapGetters('contentful', [
      'singlePage',
      'singlePages'
    ]),
    ...mapGetters([
      'lang'
    ]),
    currentPage: {
      get () {
        return this.singlePage(this.slug)
      }
	  },
    calledComponent: {
      get () {
        return this.componentsMap[this.currentPage.fields.template] || Common
      }
    }
  },
  beforeRouteEnter (from, to, next) {
    next(async (vm) => {
	    await vm.loadData()
      if (typeof vm.currentPage === 'undefined') vm.$router.replace({ name: `${vm.lang}.not-found-page` })
    })
  },
  beforeRouteUpdate (from, to, next) {
    this.loadData()
    next()
  },
  methods: {
    ...mapActions('contentful', [
      'loadSinglePages'
    ]),
    async loadData () {
      this.loading = true
      try {
        await this.loadSinglePages()
        this.loading = false
      } catch (e) {
        // TODO sentry
      }
    },
    $_discoverAssortment () {
      this.$emit('open-categories')
    }
  },
  metaInfo () {
    if (this.currentPage === undefined) return {
      title: 'Loading...',
      meta: [
        { vmid: 'description', name: 'description', content: 'Loading...' },
        { property: 'og:locale', content: 'Loading...' },
        { property: 'og:title', content: 'Loading...' },
        { property: 'og:description', content: 'Loading...' },
        { property: 'og:url', content: 'Loading...' }
      ],
      link: [
        { rel: 'alternate', href: 'Loading...', hreflang: 'it' },
        { rel: 'alternate', href: 'Loading...', hreflang: 'en' }
      ]
    }
    return {
      title: this.currentPage.fields.seoTitle,
      meta: [
        { vmid: 'description', name: 'description', content: this.currentPage.fields.seoDescription },
        { property: 'og:locale', content: this.lang },
        { property: 'og:title', content: this.currentPage.fields.seoTitle },
        { property: 'og:description', content: this.currentPage.fields.seoDescription },
        { property: 'og:url', content: `/${this.lang}/${this.currentPage.fields.slug}` }
      ],
      link: [
        { rel: 'alternate', href: `${window.location.origin}/it/${this.currentPage.fields.slug}`, hreflang: 'it' },
        { rel: 'alternate', href: `${window.location.origin}/en/${this.currentPage.fields.slug}`, hreflang: 'en' },
        { rel: 'canonical', href: location.protocol + '//' + location.host + location.pathname }
      ]
    }
  }
}
</script>